/* Barra fixa da página de linha.

   Mesma mecânica da barra de compra das LPs, com um alvo diferente: em vez de
   adicionar ao carrinho, ela leva para a grade de produtos. Some enquanto a
   grade está na tela — ali o botão seria redundante — e reaproveita a classe
   body.lph-buybar-on, que já afasta o botão do WhatsApp do rodapé. */
(function () {
  var barra = document.querySelector('[data-lof-linhabar]');
  var grade = document.getElementById('produtos');
  if (!barra || !grade) return;

  var ROLOU = 240;

  /* Medição síncrona, direto no evento de scroll — é o mesmo desenho da barra
     de compra das LPs, que já roda em produção. A primeira versão agendava o
     cálculo com requestAnimationFrame, que o navegador congela quando a aba
     não está visível: a barra ficava presa no estado anterior. Ler um único
     getBoundingClientRect por evento, com listener passivo, sai barato. */
  function pintar() {
    var r = grade.getBoundingClientRect();
    var alt = window.innerHeight || document.documentElement.clientHeight;
    var naGrade = r.top < alt - 80 && r.bottom > 100;
    var mostrar = window.scrollY > ROLOU && !naGrade;
    barra.classList.toggle('is-on', mostrar);
    document.body.classList.toggle('lph-buybar-on', mostrar);
  }

  window.addEventListener('scroll', pintar, { passive: true });
  window.addEventListener('resize', pintar);
  pintar();
})();
